import { render, staticRenderFns } from "./bindings.component.vue?vue&type=template&id=1d8108b8"
import script from "./bindings.component.vue?vue&type=script&lang=js"
export * from "./bindings.component.vue?vue&type=script&lang=js"
import style0 from "./bindings.component.vue?vue&type=style&index=0&id=1d8108b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports